/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import InfoCard from "./InfoCard";

const styles = theme => ({});

class InfoCards extends PureComponent {

    render() {
        const {classes, infoCards} = this.props;

        return (<>
                {infoCards.map((card, key) => (
                    <InfoCard
                        title={card.title}
                        body={card.body}
                        image={card.image}
                        icon={card.icon}
                        isIconImage={true}
                        key={key}
                    />
                ))}
            </>
        )
    }
}

export default withStyles(styles)(InfoCards);
